export default __webpack_public_path__ + "google-play-badge_nl.png";